import LoadHome from 'bundle-loader?lazy&name=home!./routes/home/home.jsx';
import LoadErrorList from 'bundle-loader?lazy&name=error-list!./routes/error-list/error-list.jsx';
import LoadErrorDetails from 'bundle-loader?lazy&name=error-details!./routes/error-details/error-details.jsx';
import LoadNotificationList from 'bundle-loader?lazy&name=notification-list!./routes/notification-list/notification-list.jsx';
import LoadFeedback from 'bundle-loader?lazy&name=feedback!./routes/feedback/feedback.jsx';

export const routes = [
    {
        title: 'Error Details',
        pattern: '/:companyId?/errors/:errorId',
        load: LoadErrorDetails
    },
    {
        title: 'Error Details',
        pattern: '/:companyId?/error-record/:errorId',
        load: LoadErrorDetails
    },
    {
        title: 'Errors',
        pattern: '/:companyId?/errors',
        load: LoadErrorList
    },
    {
        title: 'Notifications',
        pattern: '/:companyId?/notifications',
        load: LoadNotificationList
    },
    {
        title: 'Feedback',
        pattern: '/feedback',
        load: LoadFeedback
    },
    {
        title: 'Home',
        pattern: '/:companyId?/home',
        load: LoadHome
    },
    {
        title: 'Home',
        pattern: '/:companyId?',
        load: LoadHome
    }
];
